import React from 'react';
import ReactDOM from 'react-dom';

function ModalPortal(props) {
   const { children } = props;
   const modalRoot = document.getElementById('modal-root');

   return ReactDOM.createPortal(
      <div className="modal">{children}</div>,
      modalRoot
   );
}

export default ModalPortal;



// WEBPACK FOOTER //
// ./src/portals/ModalPortal.js